// extracted by mini-css-extract-plugin
export var box = "Section-module--box--911f0";
export var box_md = "Section-module--box_md--0629f";
export var box_xmd = "Section-module--box_xmd--c4cf3";
export var box_flex = "Section-module--box_flex--8cd55";
export var box_lg = "Section-module--box_lg--e4a89";
export var box_sm = "Section-module--box_sm--66253";
export var box_outer = "Section-module--box_outer--6b60d";
export var box_whiteBg = "Section-module--box_white-bg--6e6f0";
export var box_noMarginBottom = "Section-module--box_no-margin-bottom--f118c";
export var box_noPadding = "Section-module--box_no-padding--85e15";
export var box_outerGray = "Section-module--box_outer-gray--f8393";
export var box_dark = "Section-module--box_dark--5914b";
export var box_zIndex = "Section-module--box_z-index--fdf40";
export var box_zIndex6 = "Section-module--box_z-index-6--ffa2d";
export var box_eventsWithLine = "Section-module--box_events-with-line--e06d6";
export var box_featuresAo = "Section-module--box_features-ao--71d35";
export var box_verticalPaddings = "Section-module--box_vertical-paddings--e93f5";
export var clearP = "Section-module--clearP--9e804";
export var clearP_vc = "Section-module--clearP_vc--2b6b9";
export var section = "Section-module--section--0c365";
export var imgWrapper = "Section-module--imgWrapper--8c6e1";
export var img = "Section-module--img--2ab61";
export var infoWrapper = "Section-module--infoWrapper--7b5eb";
export var title = "Section-module--title--e8ddd";
export var subtitle = "Section-module--subtitle--f0017";
export var notification = "Section-module--notification--6dc9f";
export var fadeInAnimation = "Section-module--fadeInAnimation--295b2";
export var placeHolderShimmer = "Section-module--placeHolderShimmer--7cbfa";